// DS: i6.20
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import IconWrap from '../../IconWrap';
const Image = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread_props(_object_spread({}, props), {
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.3 2.2a.7.7 0 01.7.7v10.2a.7.7 0 01-.7.7H1.7a.7.7 0 01-.7-.7V2.9a.7.7 0 01.7-.7h12.6zm-.7 1.4H2.4v6.189l1.315-1.314a.7.7 0 01.924-.058l.066.058 1.946 1.947-1.872 1.977h1.927l4.819-5.09.064-.06a.694.694 0 01.166-.101.698.698 0 01.524.19l.027.026L13.6 8.88v3.52H8.628 13.6V3.6zM7.65 5.5a1.05 1.05 0 110 2.1 1.05 1.05 0 010-2.1z",
        clipRule: "evenodd"
    })));
};
Image.displayName = 'Image';
export default Image;

//# sourceMappingURL=Image.js.map